import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import BreaksHintModal, {
  BreaksFrom,
} from 'modules/shift_management/components/ShiftManagement/Onboarding/BreaksHintModal'

const Banner = () => {
  const [openHintModal, setOpenHintModal] = React.useState<boolean>(false)

  const [hasSeenSplitShiftsCallout, setHasSeenSplitShiftsCallout] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideSplitShiftsCalloutShiftManagement,
    false
  )

  const [hasSeenBreaksCallout, setHasSeenBreaksCallout] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideBreaksCalloutShiftManagement,
    false
  )

  const openModal = () => {
    track(trackingEvents.shiftManagement.howToSetUpBreaksStart, { from: 'rotating' })
    setOpenHintModal(true)
  }

  return (
    <Box gap="s16">
      {!hasSeenBreaksCallout && (
        <Callout
          type="info"
          title={i18n.t('shift_management.rotating_shifts.schedules.settings_callout.title')}
          description={i18n.t(
            'shift_management.rotating_shifts.schedules.settings_callout.description'
          )}
          action={
            <Button type="secondary" onClick={openModal}>
              {i18n.t('shift_management.rotating_shifts.schedules.settings_callout.action_button')}
            </Button>
          }
          onRemove={() => setHasSeenBreaksCallout(true)}
        />
      )}
      {!hasSeenSplitShiftsCallout && (
        <Callout
          type="info"
          title={i18n.t('shift_management.rotating_shifts.schedules.split_shifts_callout.title')}
          description={i18n.t(
            'shift_management.rotating_shifts.schedules.split_shifts_callout.description'
          )}
          onRemove={() => setHasSeenSplitShiftsCallout(true)}
        />
      )}
      {openHintModal && (
        <BreaksHintModal from={BreaksFrom.Rotating} onClose={() => setOpenHintModal(false)} />
      )}
    </Box>
  )
}

export default observer(Banner)
